module.exports = __webpack_public_path__ + "img/yes.1ade32ba.png";